import { Record } from 'immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const State = new Record({
    charityOption: {
        accountNumber: '',
        charityName: '',
        description: '',
        donationAmount: 0,
        id: null,
        link: '',
        logoUrlDark: '',
        logoUrlLight: '',
        sortCode: ''
    },
    isLoading: false,
    hasError: false,
});

class CharityStore extends BaseStore {
    deserialize(serialized) {
        if (serialized) {
            const {
                charityOption,
                isLoading,
                hasError,
            } = serialized;
            return new State({
                charityOption,
                isLoading,
                hasError,
            });
        }
        return new State();
    }

    getInitialState() {
        return new State();
    }

    setIsLoading(value) {
        return function() {
            this.setState(this.state.set('isLoading', value));
        };
    }

    setError() {
        this.setState(this.state.set('hasError', true));
    }

    resetError() {
        this.setState(this.state.set('hasError', false));
    }

    setCharityOptions({ charityOption }) {
        if (charityOption) {
            this.setState(
                this.state
                    .set('charityOption', charityOption)
                    .set('hasError', false),
            );
        } else {
            this.setState(this.state.set('hasError', true));
        }
    }

    getActionHandlers() {
        return {
            [ActionTypes.GET_ORDER_CHARITY_OPTIONS_STARTED]: this.setIsLoading(true),
            [ActionTypes.GET_ORDER_CHARITY_OPTIONS_SUCCESS]: this.setCharityOptions,
            [ActionTypes.GET_ORDER_CHARITY_OPTIONS_FAILED]: this.setError,
            [ActionTypes.GET_ORDER_CHARITY_OPTIONS_FINISHED]: this.setIsLoading(false),
            [ActionTypes.SET_ORDER_CHARITY_OPTIONS_SUCCESS]: this.resetError,
            [ActionTypes.SET_ORDER_CHARITY_OPTIONS_FAILED]: this.setError,
            [ActionTypes.DELETE_ORDER_CHARITY_OPTIONS_SUCCESS]: this.resetError,
            [ActionTypes.DELETE_ORDER_CHARITY_OPTIONS_FAILED]: this.setError,
        };
    }
}

const instance = new CharityStore({ storageKey: 'charity' });

export default instance;



// WEBPACK FOOTER //
// ./src/stores/CharityStore.js